import api from 'api'
import useSWR from 'swr'

/**
 * コンタクト登録済みか取得するSWR
 */

export const useCustomerRegistered = ({
  ownerId,
  isReady,
}: {
  ownerId: string | undefined
  isReady: boolean
}) => {
  const key = ownerId && isReady ? '/customers/registered' : null
  return useSWR<boolean>(
    key,
    (key) =>
      api
        .get(key as string, {
          params: { owner_id: ownerId },
        })
        .then((res) => {
          if (res.status !== 200) throw res
          return res.data
        }),
    {
      revalidateOnFocus: false,
    },
  )
}
